<template>
  <div class="flex items-center">
    <div class="form-switch">
      <input
        type="checkbox"
        :id="id"
        class="sr-only"
        :checked="value"
        @change="$emit('update:value', $event.target.checked)"
      />
      <label class="bg-slate-400 dark:bg-slate-700" :for="id">
        <span class="bg-white shadow-sm" aria-hidden="true"></span>
        <span class="sr-only">Enable Toggle</span>
      </label>
    </div>
    <span class="ml-2">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>